import { render, staticRenderFns } from "./MentPlanM.vue?vue&type=template&id=90e0c3a8&scoped=true&"
import script from "./MentPlanM.vue?vue&type=script&lang=js&"
export * from "./MentPlanM.vue?vue&type=script&lang=js&"
import style0 from "./MentPlanM.vue?vue&type=style&index=0&id=90e0c3a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e0c3a8",
  null
  
)

export default component.exports